(function () {
  var selector = '.product-countdown-promo-widget__countdown-block';

  function initBlock(block) {
    if (!block || block.__mbwCountdownInit) {
      return;
    }

    var targetAttr = block.getAttribute('data-countdown');
    if (!targetAttr) {
      hideWidget(block);
      return;
    }

    var targetDate = new Date(targetAttr);
    if (isNaN(targetDate.getTime())) {
      hideWidget(block);
      return;
    }

    block.__mbwCountdownInit = true;

    function tick() {
      var now = new Date();
      var diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        hideWidget(block);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var remainder = totalSeconds % 86400;
      var hours = Math.floor(remainder / 3600);
      remainder %= 3600;
      var minutes = Math.floor(remainder / 60);
      var seconds = remainder % 60;

      setSegmentValues(block, days, hours, minutes, seconds);
    }

    block.__mbwCountdownTimer = setInterval(tick, 1000);
    tick();
  }

  function setSegmentValues(block, days, hours, minutes, seconds) {
    setValue(block, 'days', days);
    setValue(block, 'hours', hours);
    setValue(block, 'minutes', minutes);
    if (block.querySelector('[data-countdown-unit="seconds"]')) {
      setValue(block, 'seconds', seconds);
    }
  }

  function setValue(block, unit, value) {
    var target = block.querySelector('[data-countdown-unit="' + unit + '"] [data-countdown-value]');
    if (!target) {
      return;
    }
    var text = typeof value === 'number' ? value.toString() : '0';
    if (text.length < 2) {
      text = ('0' + text).slice(-2);
    }
    target.textContent = text;
  }

  function destroyBlock(block) {
    if (block && block.__mbwCountdownTimer) {
      clearInterval(block.__mbwCountdownTimer);
      block.__mbwCountdownTimer = null;
    }
    if (block) {
      block.__mbwCountdownInit = false;
    }
  }

  function hideWidget(block) {
    destroyBlock(block);
    var widget = block.closest('.product-countdown-promo-widget');
    if (widget && widget.parentNode) {
      widget.parentNode.removeChild(widget);
      return;
    }
    if (block && block.parentNode) {
      block.parentNode.removeChild(block);
    }
  }

  function initAll(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) {
      return;
    }
    var blocks = root.querySelectorAll(selector);
    for (var i = 0; i < blocks.length; i += 1) {
      initBlock(blocks[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var blocks = event.target.querySelectorAll(selector);
    for (var i = 0; i < blocks.length; i += 1) {
      destroyBlock(blocks[i]);
    }
  });
})();
